import React from "react";
import { Flex, InputNumber } from "antd";

const toLatLng = v => {
  if (v && (v.latitude !== undefined || v.longitude !== undefined)) return { lat: v.latitude, lng: v.longitude };
  return { lat: null, lng: null };
};

export default function CoordinateField({ field, value, onChange, labels = {} }) {
  const { lat, lng } = toLatLng(value);
  const emit = (nextLat, nextLng) => {
    if (nextLat === null && nextLng === null) return onChange(field.name, null);
    onChange(field.name, { latitude: Number(nextLat), longitude: Number(nextLng) });
  };
  return (
    <Flex gap="small">
      <InputNumber
        style={{ flex: 1 }}
        step="any"
        placeholder={labels.lat}
        aria-label={labels.lat}
        value={lat ?? null}
        onChange={next => emit(next ?? null, lng)}
      />
      <InputNumber
        style={{ flex: 1 }}
        step="any"
        placeholder={labels.lng}
        aria-label={labels.lng}
        value={lng ?? null}
        onChange={next => emit(lat, next ?? null)}
      />
    </Flex>
  );
}
